// extracted by mini-css-extract-plugin
export default {"letterCard":"Letter_letterCard__sagPJ","letterBody":"Letter_letterBody__9xJ1B","letterText":"Letter_letterText__Zvybl"};